import { UserType } from '../../interfaces';

export const state: UserType = {
  id: 0,
  username: '',
  password: '',
  role: '',
};
